"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("../../hooks");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const molecules_1 = require("../../molecules");
const MultiSelectionTab_1 = require("../MultiSelectionTab");
const TabCarousel_1 = __importDefault(require("../TabCarousel"));
const analytics_1 = require("@completeanatomy/analytics");
const device_1 = require("@completeanatomy/device");
const ar_mode_1 = require("@completeanatomy/ar-mode");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const selectors_1 = require("../../selectors");
const react_1 = require("react");
const InfoBoxMobile_1 = require("../InfoBoxMobile");
const TOP_OFFSET = 56;
const selectSpecificDetails = (0, selectors_1.createPropertiesSelector)(selectors_1.selectDetails, 'names', 'isAudioPlaying', 'audio');
function InfoBox({ className, topOffset = TOP_OFFSET, withHeader, }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const { identifier } = (0, models_1.useSelectedPart)();
    const infoBoxDetails = (0, hooks_1.useSelector)(selectSpecificDetails);
    const [isAltNamesOpen, toggleAltNamesOpen] = (0, ui_1.useToggleState)(false);
    const [isOverlayPresent, setIsOverlayPresent] = (0, react_1.useState)(false);
    const isARModeActive = (0, ar_mode_1.useIsARModeActive)();
    const { isActive: isMultiSelectActive } = (0, hooks_1.useMultiSelectState)();
    const analytics = (0, analytics_1.useAnalytics)();
    const toggleAltNamesOpenWrapper = () => {
        toggleAltNamesOpen();
        analytics.log('AltNamesPressed', { name: title });
    };
    (0, react_1.useEffect)(() => {
        // Function to check if Model Downloading overlay is present
        const checkOverlayPresence = () => {
            const overlayComponent = document.querySelector('[data-component="ModelDownloadingOverlay"]');
            setIsOverlayPresent(overlayComponent !== null);
        };
        checkOverlayPresence();
        const observer = new MutationObserver(checkOverlayPresence);
        observer.observe(document.body, { childList: true, subtree: true });
        // Clean up the observer on unmount
        return () => {
            observer.disconnect();
        };
    }, [isOverlayPresent]);
    if (isMobile) {
        return (0, jsx_runtime_1.jsx)(InfoBoxMobile_1.InfoBoxMobile, { "data-e2e": 'InfoBox_InfoBoxMobile' });
    }
    const { names, audio, isAudioPlaying } = infoBoxDetails || {};
    const title = (names === null || names === void 0 ? void 0 : names.title) || '';
    const subtitle = (names === null || names === void 0 ? void 0 : names.latin) || '';
    const altNames = (names === null || names === void 0 ? void 0 : names.alternative) || [];
    const titleComponent = isMultiSelectActive ? ((0, jsx_runtime_1.jsx)(molecules_1.MultiSelectionTitle, { "data-e2e": 'InfoBox_MultiSelectionTitle' })) : ((0, jsx_runtime_1.jsx)(molecules_1.Title, { title: title, altTitle: subtitle, withAltNames: !!(altNames === null || altNames === void 0 ? void 0 : altNames.length), withAudio: Boolean(audio === null || audio === void 0 ? void 0 : audio.length), playing: isAudioPlaying, onToggleNames: toggleAltNamesOpenWrapper, "data-e2e": 'InfoBox_Title' }));
    const carouselComponent = isMultiSelectActive ? ((0, jsx_runtime_1.jsx)(MultiSelectionTab_1.MultiSelectionTab, { "data-e2e": 'InfoBox_MultiSelectionTab' })) : ((0, jsx_runtime_1.jsx)(TabCarousel_1.default, { "data-e2e": 'InfoBox_TabCarousel' }));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { id: "area-selection-portal", "data-e2e": 'InfoBox_div' }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: (!!identifier || !!isMultiSelectActive) && !isARModeActive, timeout: 500, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'InfoBox_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { "$topOffset": withHeader ? 100 : topOffset, "$isOverlayPresent": isOverlayPresent, className: className, "data-e2e": 'InfoBox_Container', children: [(0, jsx_runtime_1.jsxs)(TopSection, { "data-e2e": 'InfoBox_TopSection', children: [titleComponent, (0, jsx_runtime_1.jsx)(molecules_1.ControlsMenu, { "data-e2e": 'InfoBox_ControlsMenu' }), !!(altNames === null || altNames === void 0 ? void 0 : altNames.length) && isAltNamesOpen && ((0, jsx_runtime_1.jsx)(StyledInfoboxAltNames, { title: title, subtitle: subtitle, names: altNames, onClose: toggleAltNamesOpen, "data-e2e": 'InfoBox_StyledInfoboxAltNames' }))] }), carouselComponent] }) })] }));
}
exports.InfoBox = InfoBox;
const Container = styled_components_1.default.div `
  z-index: ${({ $isOverlayPresent }) => ($isOverlayPresent ? '0' : '1')};
  position: absolute;
  top: ${({ $topOffset }) => $topOffset}px;

  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  width: ${({ theme }) => theme.infoBoxWidth}px;
  max-height: ${({ theme, $topOffset }) => `calc(100vh - ${theme.footerHeight}px - ${$topOffset}px - env(safe-area-inset-bottom))`};
  padding: 6px 4px 0;
  overflow: hidden;

  font-size: 11px;

  background: ${({ theme }) => theme.backgroundWithOpacity};

  ${({ theme }) => ui_1.device.tablet(`
      width: ${theme.infoBoxWidth}px;
    `)}
  &.enter {
    transform: translateX(-100%);
  }

  &.enter-active {
    transform: translateX(0);

    transition: transform 500ms ease-in-out;
  }

  &.exit {
    transform: translateX(0);
  }

  &.exit-active {
    transform: translateX(-100%);

    transition: transform 500ms ease-in-out;
  }
`;
const TopSection = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;

  border-bottom: 1px solid ${({ theme }) => theme.thinLine};
`;
const StyledInfoboxAltNames = (0, styled_components_1.default)(molecules_1.AltNames) `
  position: absolute;

  top: 0;
  right: 0;
  left: 0;

  z-index: 1;
`;
